import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box, Card, CardContent, CardActions, Modal } from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword, updateProfile, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

const RegisterForm = ({ toggleDrawer }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await updateProfile(user, {
        displayName: name
      });
      setOpenModal(true);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleGoogleSignUp = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await updateProfile(user, {
        displayName: user.displayName
      });
      setOpenModal(true);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    navigate('/');
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="95vh"
        sx={{ p: { xs: 2, sm: 4 } }}
      >
        <Card sx={{ width: '100%', maxWidth: 400, p: { xs: 2, sm: 4 }, borderRadius: 4 }}>
          <CardContent>
            <Typography variant="h4" component="h1" gutterBottom align="center">
              Registrarse
            </Typography>
            {error && (
              <Typography variant="body2" color="error" align="center">
                {error}
              </Typography>
            )}
            <form onSubmit={handleSubmit}>
              <TextField
                label="Nombre"
                variant="outlined"
                margin="normal"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <TextField
                label="Correo Electrónico"
                variant="outlined"
                margin="normal"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                label="Contraseña"
                type="password"
                variant="outlined"
                margin="normal"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <TextField
                label="Confirmar Contraseña"
                type="password"
                variant="outlined"
                margin="normal"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Registrarse
              </Button>
            </form>
          </CardContent>
          <CardActions>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              startIcon={<GoogleIcon />}
              sx={{ mb: 2 }}
              onClick={handleGoogleSignUp}
            >
              Registrarse con Google
            </Button>
            <Button
              variant="text"
              color="primary"
              fullWidth
              onClick={() => navigate('/login')}
            >
              Iniciar Sesión
            </Button>
          </CardActions>
        </Card>
      </Box>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            width: '80%',
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Cuenta creada exitosamente
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Su cuenta ha sido creada exitosamente. Ahora puede iniciar sesión.
          </Typography>
          <Button onClick={handleCloseModal} sx={{ mt: 2 }}>
            Cerrar
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default RegisterForm;
